import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProjectResponse } from '../core/models/project-response';
import { environment } from "environments/environment";
import { Operation } from "app/core/interfaces/operation.interface";
import { OrganizationResponse } from "app/core/models/organization-response";

@Injectable()
export class OperationService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getOperations({ sortDirection, sortField, pageIndex, pageSize, activeFilters }: { filter: string; sortDirection: 'asc' | 'desc' | ''; sortField: string; pageIndex: number; pageSize: number; activeFilters: unknown[]; }): Observable<OrganizationResponse> {
    
    const allStringFilterAux = [];
    activeFilters.forEach((item) => {
      if (item['value'] != null && item['value'] != '') {
        const stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    const queryFilter = allStringFilterAux.join('--');

    
    const params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/operations`, {
      params: params
      }).pipe(
          
          map(res =>  <ProjectResponse>res)
      );    
    
  }


  getOperationProposes(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/operations/proposes`);
  }

  getOperationScopes(): Observable < any > {
    return this._httpClient.get(`${environment.apiUrl}/operations/scopes`);
}

getOperationStatus(): Observable < any > {
  return this._httpClient.get(`${environment.apiUrl}/operations/status`);
}

getOperation(id: string): Observable < any > {
    return this._httpClient.get(`${environment.apiUrl}/operations/${id}`);
}

createOperation(operation: Operation): Observable < any > {
    return this._httpClient.post(`${environment.apiUrl}/operations`, operation);
}

editOperation(operation: Operation, id: string): Observable < any > {
    return this._httpClient.put(`${environment.apiUrl}/operations/${id}`, operation);
}

deleteOperation(id: string): Observable < any > {
    return this._httpClient.delete(`${environment.apiUrl}/operations/${id}`);
} 
  
}
